/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Already_Have_AccountInputs */

const en_common_sign_already_have_account = /** @type {(inputs: Common_Sign_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account?`)
};

/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Common_Sign_Already_Have_AccountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_already_have_account = /** @type {((inputs?: Common_Sign_Already_Have_AccountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Already_Have_AccountInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_already_have_account(inputs)
});
export { common_sign_already_have_account as "common.sign.already_have_account" }